import { NgModule } from '@angular/core';
import { MaterialModule } from './material/material.module';
import { HeaderComponent } from './components/header/header.component';
import { RouterModule } from '@angular/router';
import { VideoPopupComponent } from './components/video-popup/video-popup.component';
import { TranslateModule } from '@ngx-translate/core';
import { NeedHelpComponent } from './components/need-help/need-help.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AccountRemovedDialogComponent } from './components/account-removed-dialog/account-removed-dialog.component';



@NgModule({
  declarations: [
    HeaderComponent,
    VideoPopupComponent,
    NeedHelpComponent,  ],
  imports: [MaterialModule, RouterModule ,TranslateModule,ReactiveFormsModule],
  exports:[
    MaterialModule,
    HeaderComponent,
    TranslateModule,
    NeedHelpComponent

  ],
})
export class SharedModule { }
